import axios from "axios";
import  { useCallback, useState } from "react";
import { toast } from "react-toastify";

const useGetDoctorList = () => {
  const [doctorList, setDoctorList] = useState([]);
  const [isDoctorListLoading, setIsLoading] = useState(false);

  const getDoctorList = useCallback(async () => {
    const token = localStorage.getItem("authToken");
    setIsLoading(true);
    try {
      const res = await axios.get(`/api/v1/users/getAllUsers`, {
        params: {
          userType: "DOCTOR"
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "hgs",
        },
      });
      const formattedData = res.data.map((item) => ({
        label: item?.name,
        value: item?.name,
        id: item?.id,
        doctorId: item?.doctorId,
      }));

      console.log(formattedData, "formattedData");
      setDoctorList(formattedData);
    } catch (error) {
      console.error("Error fetching doctor list:", error);
      toast.error("Error fetching doctor list");
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { getDoctorList, doctorList, isDoctorListLoading };
};

export default useGetDoctorList;
